module.exports = __webpack_public_path__ + "img/ertiga-xl7-naranja.5739f5b0.png";